import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addForbiddenWord,
    deleteAllForbiddenWordsByCompany,
    downloadFileWithWords,
    getForbiddenWords
} from "../../../../../../../../services/company/api";
import Translate from "../../../../../../../../components/Translate";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import DestructiveButton from "../../../../../../../../components-new/buttons/DestructiveButton";
import {addNotification as addNotificationAction} from "../../../../../../../../services/notification/action";
import {connect} from "react-redux";
import config from "../../../../../../../../config";
import Colors from "../../../../../../../../utils/Colors";
import PaperClipIcon from "../../../../../../../../assets/icons/PaperClipIcon";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import './ForbiddenWords.css';

class ForbiddenWordsConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forbiddenWords: [],
            selectedFile: null,
        };
    }

    componentDidMount() {
        const {client} = this.props;
        this.fetchForbiddenWords(client.id);
    }

    fetchForbiddenWords = (companyId) => {
        getForbiddenWords(companyId)
            .then(forbiddenWords => {
                this.setState({forbiddenWords});
            })
            .catch(error => console.error('Error fetching forbidden words:', error));
    };

    handleDeleteAll = () => {
        const {client, addNotification} = this.props;
        deleteAllForbiddenWordsByCompany(client.id)
            .then(() => {
                this.setState({forbiddenWords: []});
                addNotification("deleted", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            })
    }

    handleFileChange = (event) => {
        this.setState({selectedFile: event.target.files[0]});
    };

    handleAddWord = () => {
        const {client, addNotification} = this.props;
        const {selectedFile} = this.state;

        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const fileContent = event.target.result;
                const words = fileContent.split(/\r?\n/).filter(Boolean);
                addForbiddenWord(client.id, words)
                    .then(() => {
                        this.setState({forbiddenWords: words});
                        addNotification("addSuccess", config.notificationLevels.success)
                    })
                    .catch(() => {
                        addNotification("somethingWentWrong", config.notificationLevels.error)
                    })
            };
            reader.readAsText(selectedFile);
        }
    };

    downloadFile = () => {
        const {client} = this.props;
        downloadFileWithWords(client.id)
    }

    render() {
        const {forbiddenWords, selectedFile} = this.state;

        const hasWords = forbiddenWords.length > 0;

        return (
            <div className="stg-page">
                <div className="stg-card">
                    <div className="stg-card__head">
                        <div>
                            <p className="stg-card__note"><Translate text="forbiddenWordsExplanation"/></p>
                        </div>
                    </div>

                <div className="fw-upload">
                    <label className="fw-upload__label">
                        <input type="file" accept=".txt" onChange={this.handleFileChange}/>
                        <SilverButton
                            asDiv
                            height={'40px'}
                            width={'auto'}
                            styles={{padding: '0 20px', fontSize: '14px', minWidth: '170px', whiteSpace: 'nowrap'}}
                        >
                            <PaperClipIcon width={16} height={16} style={{color: Colors.blueDark}} stroke="currentColor"/>
                            <Translate text="chooseFile"/>
                        </SilverButton>
                    </label>

                    <span className={'fw-upload__filename' + (selectedFile ? '' : ' fw-upload__filename--empty')}>
                        {selectedFile ? selectedFile.name : <Translate text="noFileSelected"/>}
                    </span>

                    <BlueButton
                        width={'auto'}
                        height={'40px'}
                        styles={{minWidth: '160px', padding: '0 24px', whiteSpace: 'nowrap'}}
                        disabled={!selectedFile}
                        onClick={this.handleAddWord}
                    >
                        <Translate text={'add'}/>
                    </BlueButton>

                </div>

                <div className="fw-stats">
                    <span className="fw-stats__value">{forbiddenWords.length}</span>
                    <span className="fw-stats__label"><Translate text="words"/></span>
                </div>

                <div className="fw-actions">
                    <BlueButton
                        width={'auto'}
                        height={'44px'}
                        variant={'outline'}
                        styles={{minWidth: '220px', padding: '0 28px', whiteSpace: 'nowrap'}}
                        disabled={!hasWords}
                        onClick={this.downloadFile}
                    >
                        <Translate text={'download'}/>
                    </BlueButton>

                    {hasWords && (
                        <DestructiveButton
                            width={'auto'}
                            height={'44px'}
                            styles={{minWidth: '260px', padding: '0 28px', whiteSpace: 'nowrap'}}
                            onClick={this.handleDeleteAll}
                        >
                            <Translate text={'clearAttachedFile'}/>
                        </DestructiveButton>
                    )}
                </div>

                </div>
            </div>
        );
    }
}

ForbiddenWordsConfig.propTypes = {
    client: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    user: state.user,
});

const mapDispatchToProps = {
    addNotification: addNotificationAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForbiddenWordsConfig);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/forbiddenWords/ForbiddenWordsConfig.jsx